import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import auth from './modules/auth.module'
import notification from './modules/notification.module'
import app from './modules/app.module'
import camera from './modules/camera.module'
import maintenance from './modules/maintenance.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    notification,
    app,
    camera,
    maintenance
  },
  plugins: [
    createPersistedState({
      paths: ['auth']
    })
  ]
})
